<template>
  <RevButtonCard
    class="flex cursor-pointer items-center justify-between gap-16 px-16 py-24"
    hoverable
    :to="{
      name: ROUTE_NAMES.POLICY_DETAILS,
      params: { policyId: policy.policyId },
    }"
    :tracking="{
      zone: TRACKING_ZONES.POLICIES_AND_ELIGIBLE_INSURANCES,
      name: 'go-to-policy-details',
      policyName: policy.offerTitle,
      policyState: policy.state,
    }"
  >
    <div class="space-y-8">
      <div>
        <PolicyStateTag :state="policy.state" />
        <div class="body-1-bold">{{ policy.offerTitle }}</div>
      </div>
      <div class="text-static-default-low body-2">
        {{
          i18n(translations.subLabel, {
            productTitle: policy.productTitle,
          })
        }}
      </div>

      <div
        v-if="policy.state === 'NOT_STARTED'"
        class="text-static-brand-hi body-2"
      >
        <span v-if="policy.startDate">
          {{
            i18n(translations.startDate, {
              startDate: formatDate(policy.startDate),
            })
          }}
        </span>
        <span v-else> {{ i18n(translations.awaitingDeviceShipment) }} </span>
      </div>

      <div
        v-if="policy.state === 'CANCELLED'"
        class="text-static-info-hi body-2"
      >
        {{
          i18n(translations.cancelledOn, {
            endDate: formatDate(policy.endDate),
          })
        }}
      </div>

      <div v-if="policy.state === 'EXPIRED'" class="text-static-info-hi body-2">
        {{
          i18n(translations.expiredOn, {
            endDate: formatDate(policy.endDate),
          })
        }}
      </div>
    </div>
    <div class="min-h-24 min-w-24">
      <IconChevronRight />
    </div>
  </RevButtonCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonCard } from '@ds/components/ButtonCard'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import PolicyStateTag from '~/scopes/dashboard/services-hub/components/PolicyStateTag/PolicyStateTag.vue'
import {
  INSURANCE_DATE_FORMAT,
  ROUTE_NAMES,
  TRACKING_ZONES,
} from '~/scopes/dashboard/services-hub/constant'
import type { Policy } from '~/scopes/dashboard/services-hub/types'

import translations from './PolicyCard.translations'

defineProps<{
  policy: Policy
}>()

const i18n = useI18n()

function formatDate(date: string) {
  return i18n.date(new Date(date), INSURANCE_DATE_FORMAT)
}
</script>
